import produce from 'immer';
import { combineReducers } from 'redux';
import { BillingAction, BillingActionType } from '../../actions/billingActions';
import { BasePlan } from '../../types/resources';

export type PlanState = {
  allIds: string[];
  byId: Record<string, Omit<BasePlan, 'limits'>>;
};

export const initialState: PlanState = {
  allIds: [],
  byId: {},
};

const allIds = (state = initialState.allIds, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_PLANS_OK:
      return action.data.map(({ id }) => id);
    default:
      return state;
  }
};

const byId = (state = initialState.byId, action: BillingAction) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case BillingActionType.GET_PLANS_OK: {
        action.data.forEach((plan) => {
          draft[plan.id] = plan;
        });
        break;
      }

      default:
        return state;
    }
  });
};

export default combineReducers({ allIds, byId });
